import { endsWith, reduce } from "lodash";
import { formatDate } from "@backpacker/date";
import { shorten } from "@backpacker/number";
import { Locale } from "@linkfluence/models/locale";

// Match our locales to the BCP 47 language tags used by Intl's API
const localeMatcher = {
  [Locale.English]: "en-US",
  [Locale.French]: "fr-FR",
  [Locale.Chinese]: "zh-CN",
  [Locale.German]: "de-DE",
  [Locale.Japanese]: "jp",
};

export const getValidLocale = (locale: Locale) => {
  return localeMatcher[locale] ?? localeMatcher[Locale.English];
};

/**
 * eg
 *  { count_number: "123456" } -> { count: "123 k" }
 *  { today_date: "2022-10-21T14:03:27.382Z" } -> { today: "October 21, 2022" }
 *  { normal_value: "123456" } -> { normal_value: "123456" }
 * }
 */
export const formatSuffixedParams = (
  params: Record<string, string | number>,
  locale: Locale
) => {
  const keyNoSuffix = (key: string, suffix: string) =>
    key.slice(0, -suffix.length);
  return reduce(
    params,
    (acc, value, key) => {
      if (endsWith(key, "_number")) {
        acc[keyNoSuffix(key, "_number")] = shorten(locale, Number(value));
      } else if (endsWith(key, "_date")) {
        acc[keyNoSuffix(key, "_date")] = formatDate(
          String(value),
          locale,
          "LL"
        );
      } else {
        acc[key] = value;
      }
      return acc;
    },
    {}
  );
};
